import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ErrorBoundary } from '@/components/error-boundary';
import { AuthProvider } from '@/components/auth-provider';
import App from './App';
import { initGA } from '@/lib/ga';
import { ConsentBanner } from '@/components/consent-banner';
import { AnalyticsTracker } from '@/components/analytics-tracker';
import { FocusManager } from '@/components/focus-manager';
import './styles.css';
import './theme.css';

initGA();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

const root = createRoot(rootElement);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <AnalyticsTracker />
        <AuthProvider>
          <App />
          <FocusManager />
          <ConsentBanner />
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);